import { render, staticRenderFns } from "./appointmentInherit.vue?vue&type=template&id=24dee656&scoped=true&"
import script from "./appointmentInherit.vue?vue&type=script&lang=js&"
export * from "./appointmentInherit.vue?vue&type=script&lang=js&"
import style0 from "./appointmentInherit.vue?vue&type=style&index=0&id=24dee656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dee656",
  null
  
)

export default component.exports